import React from "react"
import MetaButton from "@components/MetaButton/version2"
import infoIcon from "../../assets/images/infoIcon.svg"
import useCustomTranslation from "@hooks/useCustomTranslation"

import { useRedirectToPro } from "@hooks/siteURLs"

const TextBanner = ({ countryName, dataEvent, theme }) => {
    const { t } = useCustomTranslation()
    const url = useRedirectToPro()

    //bg-lblue theme by default
    let background = "bg-lblue"
    let color = "text-g82"
    let icon = "invert-0"

    switch (theme) {
        case "bg-dblue":
            background = "bg-dblue"
            color = "text-g70"
            icon = "invert"
            break
    }

    const bgClass = `
  ${background}
  flex 
  items-center 
  justify-center 
  `

    const textClass = `
  ${color}  
  font-inter 
  text-[16px]   
  font-normal
  sm:w-[299px]
  md:w-[536px]
  desk:w-[602px]
  `
    const iconClass = `
  ${icon}
  pt-1 
  md:pt-0
`

    return (
        <div className={bgClass}>
            <div className="desk:flex px-8 mt-12 desk:mt-14 mb-[-20px] items-center">
                <div className="md:flex desk:mr-15">
                    <div className="mr-3 mt-0.5 h-0 w-[22px] md:w-[25px]">
                        <img src={infoIcon} alt="Info Icon" className={iconClass} />
                    </div>
                    <div className="ml-8 md:ml-0">
                        <div className={textClass}>
                            {countryName !== 'International' ?
                                <p>{t("metal_country_price_description", { country: t(countryName) })}</p>
                                :
                                <p>{t("metal_price_description")}</p>
                            }
                        </div>
                    </div>
                </div>
                <div className="whitespace-nowrap w-auto desk:w-auto m-8 desk:m-5 mb-2 mt-4 desk:mt-1 ">
                    <MetaButton
                        className="inline-flex"
                        as="link"
                        inverted
                        url={url}
                        dataEvent={dataEvent}>
                        {t("About_Button1")}
                    </MetaButton>
                </div>
            </div>
        </div>
    )
}

export default TextBanner
